import request from "@/utils/request";

/*
 * 商品分类
 * */
export function getCategory() {
    return request.get("/category_list", {}, {
        login: false
    });
}

/*
 * 商品详情
 * */
export function getProductDetail(id) {
    return request.get("/product/detail/" + id, {}, {
        login: false
    });
}

/*
 * 商品列表
 * */
export function getProducts(q) {
    return request.get("/products", q, {
        login: false
    });
}

/*
 * 购物车数量
 * */
export function getCartNum() {
    return request.get("/cart/count");
}

/*
 * 添加收藏
 * */
export function toCollect(id, category) {
    return request.get("/collect/add/" + id + "/" + category);
}

/**
 * 搜索推荐关键字
 */
export function getSearchKeyword() {
    return request.get("/hot_search", {}, {
        login: false
    });
}

/*
 * 购物车 添加
 * */
export function postCartAdd(data) {
    return request.post("/cart/add", data, {
        login: false
    });
}

/*
 * 购物车 获取数量
 * */
export function getCartCount(data) {
    return request.get("/cart/count", data, {
        login: false
    });
}

/*
 * 购物车列表
 * */
export function getCartList() {
    return request.get("/cart/list");
}

/*
 * 购物车 删除
 * */
export function postCartDel(ids) {
    return request.post("/cart/del", { ids });
}

/*
 * 购物车 修改商品数量
 * */
export function changeCartNum(id, number) {
    return request.post("/cart/num", {
        id,
        number
    });
}

/**
 * 店铺街
 */
export function shop_street(data) {
    return request.get("/shop_street", data, { login: false });
}

/**
 * 店铺街首页
 */
export function shop_index(data) {
    return request.get("/shop_index", data, { login: false });
}

/**
 * 店铺街首页
 */
export function shop_apply(data) {
    return request.post("/shop_apply", data, { login: false });
}

/**
 * 品牌街页面
 */
export function brand_list() {
    return request.get("/brand_list", { pc: true }, { login: false });
}

/**
 * 积分商品列表
 */
export function pointpro_list(data) {
    return request.get("/pointpro_list", data, { login: true });
}
/**
 * 积分商品详情
 */
export function pointpro_detail(data) {
    return request.get("/pointpro_detail", data, { login: true });
}



